import * as React from 'react';

import { IconButtonStyle } from './icon';

interface Props {
  Icon?: React.ComponentType;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseEnter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  rotate?: number;
  mood?: string;
  defaultColor?: string;
  hoverColor?: string;
  height?: number;
  width?: number;
  iconHeight?: number;
}

const IconButtonComponent: React.FC<Props> = (props) => {
  const {
    Icon,
    rotate,
    mood = 'default',
    defaultColor,
    hoverColor,
    onClick,
    onMouseEnter,
    onMouseLeave,
    height,
    width,
    iconHeight,
  } = props;
  return (
    <IconButtonStyle
      {...{ rotate, mood, defaultColor, height, width, iconHeight, hoverColor }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span>
        <Icon />
      </span>
    </IconButtonStyle>
  );
};

export const IconButton = React.memo(IconButtonComponent);
